export default __webpack_public_path__ + "static/media/gallery-wip-handle-neck_01.d2b344d2.jpg";